import TrialCard from './TrialCard';

export default TrialCard;
